import React from 'react';
export function Footer() {
  return <footer className="w-full bg-black border-t border-white/10 py-12 px-4" data-id="element-222">
      <div className="max-w-3xl mx-auto text-center" data-id="element-223">
        <div className="text-[#00E68A] text-2xl font-black tracking-widest mb-4" data-id="element-224">
          🌟 PROFEPACK™
        </div>
        <p className="text-gray-400 text-sm leading-relaxed mb-4 max-w-xl mx-auto" data-id="element-225">
          El sistema de planificación N°1 para docentes de Lengua y Literatura
          de secundaria en Argentina.
        </p>
        <p className="text-gray-400 text-sm italic mb-8" data-id="element-226">
          Porque enseñar Lengua no debería costarte todos los domingos del año.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-gray-400 text-sm mb-8" data-id="element-227">
          <a href="mailto:soporteprofepack@gmail.com" className="hover:text-[#00E68A] transition-colors" data-id="element-228">
            📧 soporteprofepack@gmail.com
          </a>
          <span className="hidden sm:inline" data-id="element-229">|</span>
          <a href="https://www.profepack.com" target="_blank" rel="noreferrer" className="hover:text-[#00E68A] transition-colors" data-id="element-230">
            🌐 www.profepack.com
          </a>
        </div>

        <div className="h-px bg-white/10 mb-8" data-id="element-231" />

        <p className="text-gray-500 text-xs mb-2" data-id="element-232">
          © PROFEPACK — Todos los derechos reservados
        </p>
        <p className="text-gray-500 text-xs mb-8" data-id="element-233">
          Prohibida la reproducción y redistribución sin autorización expresa
        </p>

        <p className="text-[#00E68A] text-lg font-bold italic" data-id="element-234">
          "El próximo domingo puede ser diferente."
        </p>
      </div>
    </footer>;
}